const styles = theme => ({
  gridCardsTitle: {
    width: '100%',
    padding: '12px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
  },
  gridCardItem: {
    flex: 1,
    minWidth: 300,
  },
  }); 

  export default styles;